import clipboardCopy from 'clipboard-copy';

export const copyJSONSource = (value: any) => (event: React.MouseEvent) => {
  event.stopPropagation();
  clipboardCopy(JSON.stringify(value)).catch();
};
